import { render, staticRenderFns } from "./nodeWrap.pug?vue&type=template&id=6ff20d45&lang=pug&"
import script from "./nodeWrap.ts?vue&type=script&lang=ts&"
export * from "./nodeWrap.ts?vue&type=script&lang=ts&"
import style0 from "./nodeWrap.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports